/* eslint-disable prefer-const */
import {WorkflowStepStatus} from "../models/workflow-step-status.enum";
import {Component} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {WorkflowService} from "../workflow.service";
import {DeploymentWorkflowService} from "./deployment-workflow.service";
import {SelectableAsset, selectableAssetModelListFactory} from "../../types/selectable-asset";
import {KeyByObject} from "../../misc/reduce-helpers";
import {WorkflowStep} from "../workflow-step";
import {exposeComponentInDebugMode} from "../../misc/expose-component-in-debug-mode.decorator";
import {handleErrors} from "../../misc/handle-errors.decorator";
import {toggleLoading} from "../../misc/loading.decorator";
import {DialogService} from "../../bootstrap-modal/dialog.service";
import {AssetDataValidationModel, AssetService} from "../../asset/asset.service";
import {AssetRemovalService} from "../../asset/asset-removal.service";
import {AccessoryService} from "../../accessory/accessory.service";
import {ProjectService} from "../../project/project.service";
import {SiteService} from "../../sites/site.service";
import {ProjectModel} from "../../project/project.model";
import {ItsmContactModel, itsmContactModelListFactory} from "../../contact/itsm-contact.model";
import {ItsmAddressModel, ItsmProjectSettableAddressesModel, itsmProjectSettableAddressesModelFactory} from "../../address/itsm-address.model";
import {get} from "lodash";
import _ = require("lodash");
import {AssetAvailableDeviceModel, AssetGqlModel} from "../../asset/asset.gql-model";
import {DataFromEditAssetModel} from "../site/individual-site-design.component";
import {MultiError} from "../../errors/multi-error";
import {SiteWorkflowService} from "../site/site-workflow.service";
import {
  DropdownsModel,
  ListSiteGroupModel,
  PurchaseOrderModel,
  SiteContactsModel,
  SiteContractModel,
} from "../site/assets-dropdowns-info-model";
import {ConfirmDialogService} from "../../confirm-dialog/confirm-dialog-service";
import {StandaloneAccessoryGqlModel} from "../../accessory/standalone-accessory.gql-model";
import {SoftwareGqlModel, SoftwareInputDataGqlModel} from "../../software/software.gql-model";
import {DataFromEditAccessoryModel} from "../../asset/edit-asset.component";
import {TARGET_SYSTEM} from "../../helpers/app-constants";
import { AppSettingsService } from "../../app-settings/app-settings.service";
import {CostCenterModel} from "../../cost-center/cost-center.model";
import {CostCenterService} from "../../cost-center/cost-center.service";
import {BillFromValue} from "../../bill-from/bill-from-with-region.model";
import {BillFromService} from "../../bill-from/bill-from.service";
import {HasuraGraphqlService} from "../../graphql/hasura-graphql-service";
import {Query} from "../../graphql/query-constant";
import { masterAgreementStatusValues } from "../../project/master-agreement-status";
import {PCAcknowledgmentDialogComponent} from "./pc-acknowledgement/pc-acknowledgment-dialog.component";

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_LIMIT = 10;

function tokenizeString(str, tokenizers = "\\s") {
  if (!str) return [];
  const regex = new RegExp(`(?:[^${tokenizers}"]+|"[^"]*")+`, "g");
  return str.match(regex);
}

function stripQuotes(str) {
  if (!str || !str.trim()) return "";
  const result = str.match(/^"(.*)"$/);
  if (result && result.length > 1) return result[1];
  return str;
}

function cleanParam(param = "") {
  const clean = ((typeof param) !== "string") ? `${param}` : param;
  return clean.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
}

@Component({
  templateUrl: "./send-devices-to-itsm.template.pug",
  providers: [
    DeploymentWorkflowService,
    AssetRemovalService,
    AssetService,
    AccessoryService,
    DialogService,
    ProjectService,
    SiteWorkflowService,
    ConfirmDialogService,
    SiteService,
    BillFromService,
    HasuraGraphqlService,
  ],
})
@exposeComponentInDebugMode()
export class SendDevicesToITSMComponent extends WorkflowStep {
  projectId: string;
  disableStep: boolean = false;
  POR954_TMC: boolean;
  error: Error;
  disableAll: boolean = false;
  allRejected: boolean = false;
  deploymentId: string = "";
  assets: SelectableAsset[] = [];
  filterAssets: SelectableAsset[] = [];
  displayAssets: SelectableAsset[] = [];
  private assetsToUpload: {[key: string]: boolean} = {};
  private associatedSoftwareToUpload: {[key: string]: boolean} = {};
  private associatedAccessoriesToUpload: {[key: string]: boolean} = {};
  blocked: boolean;
  errorMessages: any[] = [];
  onBoardInProgress: boolean = false;
  subscriptions: any[] = [];
  project: ProjectModel;
  isLegacy: boolean = true;
  targetSystem: string;
  warningMessages: any = [];
  errorDetail: string = "yes";
  partnersValidation = [
    {
      humanReadableName: "Bill To BP ID",
      brokerPartnerTypeOutput: "BILL_TO",
    },
    {
      humanReadableName: "Payer BP ID",
      brokerPartnerTypeOutput: "PAYER",
    },
    {
      humanReadableName: "Customer BP ID",
      brokerPartnerTypeOutput: "SOLD_TO",
    },
    {
      humanReadableName: "HP Contract Admin Contact",
      brokerPartnerTypeOutput: "HP_CONTRACT_ADMIN_CONTACT",
    },
  ];

  hideInvalidAssets: boolean = false;
  hideCompletedAssets: boolean = true;

  currentPage: number = DEFAULT_PAGE;
  pageSize: number = DEFAULT_PAGE_LIMIT;
  maxPages: number;
  searchText: string = "";

  selectedIndex: number = -1;
  internalLoading: boolean = false;
  disableCOA: boolean = false;
  CR923: boolean = false;
  public statusKey: string;
  stepName: string;
  assetOpened: boolean = false;
  assetChanged: boolean = false;
  successfulSave: boolean;

  currentAsset: AssetGqlModel = new AssetGqlModel({});
  currentAssetChanged: AssetGqlModel = new AssetGqlModel({});
  currentDevice: AssetAvailableDeviceModel = new AssetAvailableDeviceModel({});
  currentAccessory: StandaloneAccessoryGqlModel = new StandaloneAccessoryGqlModel({});
  currentSoftware: SoftwareGqlModel = new SoftwareGqlModel({});
  currentDeviceType: string = "";
  groupList: ListSiteGroupModel[];
  siteContactsList: SiteContactsModel[];
  dropdowns: DropdownsModel;
  purchasOrdersList: PurchaseOrderModel[];
  softwareSaved: boolean = false;
  processingAsset: boolean = false;
  disableCOAEditableLink: boolean = true;
  accountDetails;
  isNovationProcess: boolean = false;
  public itsmCustomInformation;
  public enableCustomFieldsFlag: boolean = false;
  public enableMultipleCA: boolean = false;
  public siteContract: SiteContractModel[];
  public itsmContractAccount: {"cId": string, "name": string, "alternatePayer": string, billToParty: string} [] = [];
  public billFromAccounts: BillFromValue[];
  public showBillFrom: boolean = false;
  public enableAssetColorsFlag: boolean = false;
  public enablePOR0241: boolean = false;

  ContractualContactTypes: any = {
    billTo: [],
    accDelMgr: [],
    contractAdmin: [],
    hpInvoice: [],
    sales: [],
    invoice: [],
  };

  itsmContacts: any = [];
  itsmContactsWithItsmIds: any [];
  itsmContactsWithBpId: any = [];
  nonHpItsmContactsWithBpId: any = [];
  itsmContactsWithBpIdMap: any = {};

  enableBillFrom:boolean = false;
  solutionTypes = {
    asset: "Device",
    accessory: "Accessory",
    software: "Software",
    "asset removal": "Asset Removal",
  };

  pendingStatusValues = {
    "sent-to-broker": true,
    "waiting-for-onboarding": true,
    "waiting-for-asset-create": true,
  };

  blockedStatusValues = {
    "sent-to-broker": true,
    "waiting-for-onboarding": true,
    "waiting-for-asset-create": true,
    "upload-failed": true,
    "direct-purchase": true,
    "rejected-asset" : true,
  }

  completeStatusValues = {
    "exists-in-itsm": true,
    "found-in-itsm": true,
    "removal-in-itsm": true,
  }

  assetStateList = [
    {key: "missing-information", text: "Missing or invalid asset details", color: "#eb9b03", icon: "warning"},
    {key: "ready", text: "Ready to upload", color: "#000000", icon: "none"},
    {key: "upload-failed", text: "Upload failed", color: "#6f1212", icon: "error"},
    {key: "exists-in-itsm", text: "Device is in ITSM", color: "#0f590f", icon: "ok"},
    {key: "found-in-itsm", text: "Device was found in ITSM", color: "#0f590f", icon: "ok"},
    {key: "removal-in-itsm", text: "Device was removed from ITSM", color: "#0f590f", icon: "ok"},
    {key: "validated", text: "Dry Run Successful", color: "#000000", icon: "none"},
    {key: "sent-to-broker", text: "Waiting for response", color: "#0096d6", icon: "loading"},
    {key: "waiting-for-asset-create", text: "Waiting for asset create", color: "#0096d6", icon: "loading"},
    {key: "waiting-for-onboarding", text: "Updating ITSM data", color: "#0096d6", icon: "loading"},
    {key: "direct-purchase", text: "This product is of type direct purchase.", color: "#6f1212", icon: "error"},
    {key: "rejected-asset", text: "Rejected", color: "#FF0000", icon: "error"},
    {key: "error", text: "Error", color: "#6f1212", icon: "error"},
  ];

  // ITSM data
  public itsmDataReady = false;
  itsmAddressInfo: ItsmProjectSettableAddressesModel;
  settableAddresses: ItsmAddressModel[] = [];
  settableAddressesMap: any = {};
  settableAddressesWithItsmBuildingIds: ItsmAddressModel[] = []; // Only send these addresses to the dialog
  itsmSiteContacts: ItsmContactModel[] = [];
  itsmSiteContactsMap: any = {};
  itsmSiteContactsWithItsmId: ItsmContactModel[] = [];
  itsmSiteContactsForSelectedDevice: ItsmContactModel[] = [];
  public devicesAssoc: object = {};
  costCenters: CostCenterModel[] = [];
  public isProjectInMaintenance = false;


  public assetAssociations = {
    accessories: 0,
    software: 0,
  };

  private _assetsIdsToUpload: string[] = [];
  CR978_TMC: boolean;

  set assetsIdsToUpload(assetsIdsToUpload: string[]) {
    this._assetsIdsToUpload = assetsIdsToUpload;
  }

  get assetsIdsToUpload(): string[] {
    return this._assetsIdsToUpload || [];
  }

  setAssetsIdsToUpload() {
    const assetIds = Object.keys(this.assetsToUpload);
    const associatedAccessoryIds = Object.keys(this.associatedAccessoriesToUpload);
    const associatedSoftwareIds = Object.keys(this.associatedSoftwareToUpload);

    this.assetsIdsToUpload = [...assetIds, ...associatedAccessoryIds, ...associatedSoftwareIds];
  }

  updateItsmAddressMapsHelper() {
    this.settableAddresses.sort((a, b) => {
      if ((a.itsmName || "").toLowerCase() > (b.itsmName || "").toLowerCase()) return 1;
      return -1;
    });
    this.settableAddressesMap = this.settableAddresses.reduce((acc, it) => { acc[it.id] = it; return acc; }, {});
    this.settableAddressesWithItsmBuildingIds = this.settableAddresses.filter(it => it.itsmBuildingId);
  }

  openMessageToTransitionLeads() {
    const selectedAssetIds = this.assets
      .filter(asset => asset.selectedNew && asset.type === "asset")
      .map(asset => asset.id);
  
    if (selectedAssetIds.length !== 0) {
      this.router.navigate(['/workflow', this.workflowService.workflowConfig.id, 'sendDevicesToITSM', 'messageToTransitionLeads'], {
        queryParams: { assetIds: selectedAssetIds.join(',') }
      });
    }
  }

  updateItsmContactMapsHelper() {
    this.itsmSiteContacts.sort((a, b) => {
      if ((a.emailAddress || "").toLowerCase() > (b.emailAddress || "").toLowerCase()) return 1;
      return -1;
    });
    this.itsmSiteContactsMap = this.itsmSiteContacts.reduce((acc, it) => { acc[it.id] = it; return acc; }, {});
    this.itsmSiteContactsWithItsmId = this.itsmSiteContacts.filter(it => !!it.itsmContactId);
  }

  @handleErrors()
  async loadItsmData() {
    if (!this.workflowTargetInfo.targetId) return;
    this.isLegacy = this.workflowService.workflowConfig.targetSystem === TARGET_SYSTEM.LEGACY;
    this.targetSystem = this.workflowService.workflowConfig.targetSystem;
    Query.DEPLOY_DEVICE.variables.projectId = this.projectId;
    const sendDeviceQueryParam = {
      projectId: this.projectId,
      query: Query.DEPLOY_DEVICE,
      uiAction: "SEND-DEVICES-TO-ITSM",
    };

    Query.GLOBAL_OPP_ID.variables.projectId = this.projectId;

    const contactParams = {
      projectId: this.projectId,
      uiAction: "SEND-DEVICES-TO-ITSM",
      queryType: "Global-Deal",
      query: Query.GLOBAL_OPP_ID,
    };
    Query.SITE_DEPLOYMENT.variables.id = this.deploymentId;
    const siteDeploymentParam = {
      projectId: this.projectId,
      uiAction: "DEPLOY-DEVICE",
      query: Query.SITE_DEPLOYMENT,
    };
    Query.PROJECT_SITES.variables.projectId = this.projectId;
    const projectSitesQuery = {
      projectId: this.projectId,
      uiAction: "PROJECT-SITES",
      query: Query.PROJECT_SITES,
    };
    let multipleCA = true;
    let POR024 = true;
    let enableApolloProjectQuery = true;
    let assetList;
    // let itsmAddressInfo;
    let tmcProjectDeployDevice;
    let POR89_2_flag = true;
    let POR89_2_TMC_flag = true;
    let POR024_1 = true;
    this.enableCustomFieldsFlag = true;
    let contactResponse;
    let siteDeplyment;
    let POR606_TMC = false;
    let projectSites;
    let featurePermissions;
    [
      assetList,
      contactResponse,
      tmcProjectDeployDevice,
      siteDeplyment,
      featurePermissions,
      projectSites,
    ] = await Promise.all([
      this.deploymentWorkflowService.getAssetListFromITSM(this.workflowTargetInfo.targetId).toPromise(),
      this.hasuraGqlService.getResponseFromHasura(contactParams),
      this.hasuraGqlService.getResponseFromHasura(sendDeviceQueryParam),
      this.hasuraGqlService.getResponseFromHasura(siteDeploymentParam),
      this.appSettingsService.getFeaturePermissionsList(["POR606_TMC", "CR923_COA_TMC"]),
      this.hasuraGqlService.getResponseFromHasura(projectSitesQuery),
      this.loadFinancialContact(),
    ]);
    this.enableAssetColorsFlag = POR89_2_flag || POR89_2_TMC_flag;
    POR606_TMC = featurePermissions["POR606_TMC"];
    this.CR923 = featurePermissions["CR923_COA_TMC"];
    if (this.CR923) {
      for (const asset of assetList.rows) {
        if (asset.statusKey === "rejected-asset") {
          if (asset.associatedAccessories) {
            for (const acc of asset.associatedAccessories) {
              acc.disabled = true;
            }
          }
          if (asset.associatedSoftware) {
            for (const soft of asset.associatedSoftware) {
              soft.disabled = true;
            }
          }
        }
      }
    }
    this.enablePOR0241 = POR024_1;
    let currentMaStatus;
    let projectStatus;
    if (tmcProjectDeployDevice && tmcProjectDeployDevice.body.data.global_deal_settings.length > 0) {
      if (tmcProjectDeployDevice.body.data.global_deal_settings[0].project) {
        currentMaStatus = tmcProjectDeployDevice.body.data.global_deal_settings[0].project.currentMaStatus;
        projectStatus = tmcProjectDeployDevice.body.data.global_deal_settings[0].project.projectStatus;
      }
    }
    if (POR606_TMC) {
      if (currentMaStatus === masterAgreementStatusValues.maintenance.typeId) {
        this.warningMessages.push(`The opportunity is under maintenance, Provider Contract creation is not allowed. Please come back later.`);
        this.isProjectInMaintenance = true;
      } else {
        this.isProjectInMaintenance = false;
      }
    }
    if (projectStatus === 'draft') {
      this.isNovationProcess = true;
    } 
    if (tmcProjectDeployDevice && tmcProjectDeployDevice.body.data.global_deal_settings.length > 0 &&
      tmcProjectDeployDevice.body.data.global_deal_settings[0].projectCostCenter &&
      tmcProjectDeployDevice.body.data.global_deal_settings[0].projectCostCenter.cost_centers) {
      this.costCenters = tmcProjectDeployDevice.body.data.global_deal_settings[0].projectCostCenter.cost_centers;
    }
    this.enableMultipleCA = multipleCA && POR024;
    if (enableApolloProjectQuery) {
      /*const params: any = `
        id
        purchaseOrderSplit
        defaultContractAccountId
        billToAddress
        payerAddress
        soldToAddress
        hpContractAdminContact
        countryId
        billFromStructure`;
      this.project = await this.projectService.getProjectDetails(this.projectId, params);*/
      const params: any = `
        id
        purchaseOrderSplit: purchase_order_split
        defaultContractAccountId: default_contract_account_id
        billToAddress: address {
          id
          name1
          name2
          line1
          line2
          city
          region
          postalCode: postal_code
          country {
            country_name
            created_at
            geo_region_id
            updated_at
          }
          customShippingLabel1: custom_label_1
          customShippingLabel2: custom_label_2
          deliveryType: delivery_type
          businessPartnerId: business_partner_id
          itsmSiteId: itsm_site_id
          itsmSiteName: itsm_site_name
          itsmBuildingId: itsm_building_id
          itsmBuilding: itsm_building
          buildingTypes: building_types
          country_id
        }
        payerAddress: addressByPayerAddressId {
          id
          name1
          name2
          line1
          line2
          city
          region
          postalCode: postal_code
          country {
            country_name
            created_at
            geo_region_id
            updated_at
          }
          customShippingLabel1: custom_label_1
          customShippingLabel2: custom_label_2
          deliveryType: delivery_type
          businessPartnerId: business_partner_id
          itsmSiteId: itsm_site_id
          itsmSiteName: itsm_site_name
          itsmBuildingId: itsm_building_id
          itsmBuilding: itsm_building
          buildingTypes: building_types
          country_id
        }
        soldToAddress: addressBySoldToAddressId {
          id
          name1
          name2
          line1
          line2
          city
          region
          postalCode: postal_code
          country {
            country_name
            created_at
            geo_region_id
            updated_at
          }
          customShippingLabel1: custom_label_1
          customShippingLabel2: custom_label_2
          deliveryType: delivery_type
          businessPartnerId: business_partner_id
          itsmSiteId: itsm_site_id
          itsmSiteName: itsm_site_name
          itsmBuildingId: itsm_building_id
          itsmBuilding: itsm_building
          buildingTypes: building_types
          country_id
        }
        hpContractAdminContact: contactByHpContractAdminContactId {
          businessPartnerId: business_partner_id
        }
        countryId: country_id
        billFromStructure: bill_from_structure`;
        this.project = await this.hasuraGqlService.getProjectResponseFromHasura(this.workflowTargetInfo.projectId, params);
    } else {
      this.project = await this.projectService.getProjectById(this.projectId).toPromise();
    }
    const {
      defaultContractAccountId,
      billToAddress,
      payerAddress,
      soldToAddress,
      hpContractAdminContact,
    } = this.project;

    if (!defaultContractAccountId && !this.enableMultipleCA) {
      this.warningMessages.push(`Send to ITSM will fail, please create and select a Contract Account.`);
    }
    [billToAddress, payerAddress, soldToAddress, hpContractAdminContact].forEach((it, index) => {
      if (!it.businessPartnerId) {
        this.warningMessages.push(`Send to ITSM will fail. Required Partner
        ${this.partnersValidation[index].humanReadableName} is not set.`);
      }
    });

    const {rows} = assetList;

    this.assetsToUpload = rows
      .filter(it => !it.disabled && it.statusKey !== 'rejected-asset')
      .reduce((acc, row) => acc.add(row.id, !row.disabled), new KeyByObject())
      .toObject();
    this.associatedAccessoriesToUpload = {};
    this.associatedSoftwareToUpload = {};

    this.allRejected = rows.filter(it => this.assetsToUpload[it.id])
  .every(asset => asset.statusKey === 'rejected-asset');

    rows.filter(it => this.assetsToUpload[it.id]).forEach((asset) => {
      //fetch statusKey of each asset
      this.statusKey = asset.statusKey;
      // Only initially set the associated stuff if the parent is to be up to go as well
      // TODO - this should change once the logic for "Hide Assets / Removals already in ITSM is fixed, but not before
      asset.associatedAccessories.forEach((accessory) => {
        this.associatedAccessoriesToUpload[accessory.id] = !accessory.disabled;
      });
      asset.associatedSoftware.forEach((software) => {
        this.associatedSoftwareToUpload[software.id] = !software.disabled;
      });
    });

    this.assets = [];
    this.assets = selectableAssetModelListFactory(
      rows,
      {
        ...this.assetsToUpload,
        ...this.associatedAccessoriesToUpload,
        ...this.associatedSoftwareToUpload,
      },
    );
    this.recalculateMaxPages();

    const isComplete = this.assets.every((it) => {
      if (!this.completeStatusValues[it.statusKey]) return false;
      if (
        it.associatedAccessories &&
        !it.associatedAccessories.every(it2 => this.completeStatusValues[it2.statusKey])
      ) {
        return false;
      }

      if (
        it.associatedSoftware &&
        !it.associatedSoftware.every(it2 => this.completeStatusValues[it2.statusKey])
      ) {
        return false;
      }

      return true;
    });
    if (isComplete) {
      await this.workflowService.setStepStatus(WorkflowStepStatus.Completed);
    }

    if (rows.some(it => it.collectMethod === "Manual")) { // Explicitly check for manual in case we don't have it set
      await this.deploymentWorkflowService.enableExportPageCounts(this.workflowService.workflowConfig.id).toPromise();
    }

    const inNeedOfMonitoring = this.assets.some((it) => {
      if (this.blockedStatusValues[it.statusKey]) return true;
      if (it.associatedAccessories && it.associatedAccessories.some(it2 => this.blockedStatusValues[it2.statusKey])) {
        return true;
      }

      if (it.associatedSoftware && it.associatedSoftware.some(it2 => this.blockedStatusValues[it2.statusKey])) {
        return true;
      }

      return false;
    });
    if (inNeedOfMonitoring) {
      this.blocked = true;
      this.disableAll = true;
      this.getDeploymentStatus();
    }
    this.setAssetsIdsToUpload();

    this.loadList();
    let addressResponse;
    if (siteDeplyment && siteDeplyment.body.data.site_deployment.length > 0 &&
      siteDeplyment.body.data.site_deployment[0].assets && siteDeplyment.body.data.site_deployment[0].assets.length > 0 ) {
      const siteIds:any = [];
      let settableAddresses;
      const itsmSiteIds = projectSites.body.data.site.map(site => site.address.siteId);
      /* for(const asset of siteDeplyment.body.data.site_deployment[0].assets) {
          if(asset && asset.site && asset.site.address && asset.site.address.itsm_site_id) {
            siteIds.push(asset.site.address.itsm_site_id);
          }
        } */
      Query.DEPLOY_ADDRESS.variables.siteId = itsmSiteIds;
      const deployAddressParam = {
        projectId: this.projectId,
        query: Query.DEPLOY_ADDRESS,
        uiAction: "DEPLOY-DEVICE",
      };
      addressResponse = await this.hasuraGqlService.getResponseFromHasura(deployAddressParam);
      if (addressResponse && addressResponse.body.data && addressResponse.body.data.settableAddresses &&
        addressResponse.body.data.settableAddresses.length > 0) {
        let deployAddress: ItsmProjectSettableAddressesModel = {
          settableAddresses: addressResponse.body.data.settableAddresses,
        };
        deployAddress = itsmProjectSettableAddressesModelFactory(deployAddress);
        this.itsmAddressInfo = deployAddress;
        this.settableAddresses = deployAddress.settableAddresses;
        // this.defaultContacts.serviceAddressId = deployAddress.serviceAddressId;
        // this.defaultContacts.tonerAddressId = deployAddress.tonerAddressId;
      }
    }
    let contacts = contactResponse && contactResponse.body && contactResponse.body.data &&
      contactResponse.body.data.contacts && contactResponse.body.data.contacts.length > 0 ?
      contactResponse.body.data.contacts : [];
    contacts = _.uniqBy(contacts, "itsmContactId");
    contacts = itsmContactModelListFactory(contacts);
    // contacts.forEach(item => item.name = `${item.firstName} ${item.lastName}`);
    let itsmSiteContacts;
    if (this.targetSystem === TARGET_SYSTEM.PMPS_PAGE ||
      this.targetSystem === TARGET_SYSTEM.MIGRATION_IPSO_PAGE ||
      this.targetSystem === TARGET_SYSTEM.MP_FLEX_RESELL ||
      this.targetSystem === TARGET_SYSTEM.PMPS_SELL_THROUGH) {
      itsmSiteContacts = contacts.filter((_contact) => {
        if (_contact.resellerCustomerId && _contact.relatedAccountIds &&
            _contact.relatedAccountIds.find(rc => rc === _contact.resellerCustomerId)) {
          return _contact;
        }
      });
    } else {
      itsmSiteContacts = contacts;
    }
    this.itsmSiteContacts = itsmSiteContacts && itsmSiteContacts.length ? itsmSiteContacts : [];
    this.updateItsmAddressMapsHelper();
    this.updateItsmContactMapsHelper();
    this.itsmDataReady = true;
    if (this.enableCustomFieldsFlag && tmcProjectDeployDevice &&
      tmcProjectDeployDevice.body.data.global_deal_settings.length > 0 &&
      tmcProjectDeployDevice.body.data.global_deal_settings[0].project &&
      tmcProjectDeployDevice.body.data.global_deal_settings[0].project.customHeaders) {
      const labelValues = tmcProjectDeployDevice.body.data.global_deal_settings[0].project.customHeaders || {};
      const customLabelArray = [];
      const keys = Object.keys(labelValues);
      for (let i = 0; i < keys.length - 1; i++) {
        const key = keys[i];
        customLabelArray.push({number: i + 1, value: labelValues[key]});
      }
      this.itsmCustomInformation = customLabelArray;
    }
    this.showBillFrom = await this.billFromService.showBillFrom(this.project) &&
      this.billFromService.isDecentralized(this.project);
    if (this.showBillFrom) {
      await this.loadBillFromBuildings();
    }

    if (this.enableMultipleCA) {
      if (tmcProjectDeployDevice && tmcProjectDeployDevice.body.data.global_deal_settings.length > 0 &&
        tmcProjectDeployDevice.body.data.global_deal_settings[0].project &&
        tmcProjectDeployDevice.body.data.global_deal_settings[0].project.target_system) {
        let contractAccountData = tmcProjectDeployDevice.body.data.global_deal_settings[0].project.target_system === "pmpsp" ||
          tmcProjectDeployDevice.body.data.global_deal_settings[0].project.target_system === "mimp"  ||
          tmcProjectDeployDevice.body.data.global_deal_settings[0].project.target_system === "mpflexr" ||
          tmcProjectDeployDevice.body.data.global_deal_settings[0].project.target_system === TARGET_SYSTEM.PMPS_SELL_THROUGH ?
          tmcProjectDeployDevice.body.data.global_deal_settings[0].project.partnerContractAccounts ?
            tmcProjectDeployDevice.body.data.global_deal_settings[0].project.partnerContractAccounts.contract_accounts :
            [] : tmcProjectDeployDevice.body.data.global_deal_settings[0].project.customerContractAccounts ?
            tmcProjectDeployDevice.body.data.global_deal_settings[0].project
              .customerContractAccounts.contract_accounts : [];
        contractAccountData = contractAccountData.filter(it => it.status);
        const projectOpportunityId = tmcProjectDeployDevice.body.data.global_deal_settings[0].project.opportunityId;
        this.itsmContractAccount = contractAccountData.map((item) => {
          let contractAcct;
          if (this.enablePOR0241 && projectOpportunityId &&
            !item.contracts.find(contract => contract.opportunityId === projectOpportunityId)) {
            contractAcct = undefined;
          } else {
            contractAcct = {
              name: item.contractAccountName,
              cId: item.contractAccountId,
              alternatePayer: item.alternatePayer,
              billToParty: item.billToParty,
              businessPartner: item.businessPartner
            };
          }
          return contractAcct;
        }).filter(account => account !== undefined);
      }
    }

    if (addressResponse && addressResponse.body.data && addressResponse.body.data.settableAddresses &&
      addressResponse.body.data.settableAddresses.length > 0 &&
      siteDeplyment && siteDeplyment.body.data.site_deployment.length > 0 &&
      siteDeplyment.body.data.site_deployment[0].site) {
      let deployAddress: ItsmProjectSettableAddressesModel = {
        settableAddresses: addressResponse.body.data.settableAddresses,
        tonerAddressId: siteDeplyment.body.data.site_deployment[0].site.toner_address_id,
        serviceAddressId: siteDeplyment.body.data.site_deployment[0].site.service_address_id,
        physicalAddressId: siteDeplyment.body.data.site_deployment[0].site.site_address_id,
      };
      deployAddress = itsmProjectSettableAddressesModelFactory(deployAddress);
      this.itsmAddressInfo = deployAddress;
      this.settableAddresses = deployAddress.settableAddresses;
      this.defaultContacts.serviceAddressId = deployAddress.serviceAddressId;
      this.defaultContacts.tonerAddressId = deployAddress.tonerAddressId;
    }
  }


  @handleErrors()
  async autoSave(): Promise<boolean> {
    const assetChanges = {
      asset: this.currentAssetChanged,
      changes: this.assetChanged,
    };
    await this.save(assetChanges);
    if (!this.successfulSave) return false;

    await this.workflowService.setStepStatus(WorkflowStepStatus.Completed);
    return true;
  }

  @toggleLoading()
  @handleErrors()
  async ready() {
    this.loading = true;
    this.projectId = this.workflowService.workflowConfig.projectId;
    this.deploymentId = this.workflowTargetInfo.targetId;
    this.stepName = get(this.workflowService.currentStep, "stepName");
    this.error = undefined;
    // await this.loadData();
    await this.loadItsmData();
    this.loading = false;
  }

  updateSelection(asset: any): void {
    const {id, selectedNew} = asset;
    const exists = this.assetsToUpload[id];
    if (selectedNew && !exists) {
      this.assetsToUpload[id] = true;
    } else if (!selectedNew && exists) {
      const assetFind = this.assets.find(it => it.id === id);
      if (assetFind && !assetFind.installed) {
        if (assetFind.associatedSoftware) { // Unselect any associated software
          assetFind.associatedSoftware.forEach((software) => {
            const existsSoft = this.associatedSoftwareToUpload[software.id];
            if (software.selectedNew && existsSoft) {
              software.selectedNew = false;
              delete this.associatedSoftwareToUpload[software.id];
            }
          });
        }

        if (assetFind.associatedAccessories) {
          assetFind.associatedAccessories.forEach((accessory) => {
            const existsAcc = this.associatedAccessoriesToUpload[accessory.id];
            if (accessory.selectedNew && existsAcc) {
              accessory.selectedNew = false;
              delete this.associatedAccessoriesToUpload[accessory.id];
            }
          });
        }
      }
      delete this.assetsToUpload[id];
    }
    this.setAssetsIdsToUpload();
  }

  updateSoftwareSelection(software: any, asset: any): void {
    const {id, selectedNew} = software;
    const exists = this.associatedSoftwareToUpload[id];
    if (selectedNew && !exists) {
      this.associatedSoftwareToUpload[id] = true;
      if (!asset.selectedNew && !asset.installed) {
        asset.selectedNew = true;
        this.assetsToUpload[asset.id] = true;
      }
    } else if (!selectedNew && exists) {
      delete this.associatedSoftwareToUpload[id];
    }

    this.setAssetsIdsToUpload();
  }

  updateAccessorySelection(accessory: any, asset: any): void {
    const {id, selectedNew} = accessory;
    const exists = this.associatedAccessoriesToUpload[id];
    if (selectedNew && !exists) {
      this.associatedAccessoriesToUpload[id] = true;
      if (!asset.selectedNew && !asset.installed) {
        asset.selectedNew = true;
        this.assetsToUpload[asset.id] = true;
      }
    } else if (!selectedNew && exists) {
      delete this.associatedAccessoriesToUpload[id];
    }

    this.setAssetsIdsToUpload();
  }

  @handleErrors()
  async edit(asset: SelectableAsset, index?: number) {
    this.disableCOA = true;
    if (this.internalLoading) return;
    asset.isClicked = true;
    try {
      
      this.internalLoading = true;
      switch (asset.type) {
        case "asset":
        case "accessory":
        case "software":
          await this.showContent(index, asset);
          break;
        case "asset removal":
          await this.assetRemovalService.editAsset(asset.id, this.projectId);
          break;
        default:
          asset.isClicked = false;
          throw new Error("Could not edit this item.");
      }
      this.internalLoading = false;
      asset.isClicked = false;
    } catch (e) {
      this.internalLoading = false;
      asset.isClicked = false;
      throw (e);
    }
  }

  private loadList(): void {
    this.clearAndCloseCurrentAsset();

    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    this.filterAssets = this.assets.filter((asset) => {
      if (this.searchText) {
        const values = [
          asset.id,
          asset.serialNumber,
          asset.assetTag,
          asset.building,
          asset.floor,
          asset.floorMapId,
          asset.productNumber,
          asset.quicksilver,
          asset.friendlyName,
        ];

        const searchFailures = tokenizeString(this.searchText) // split on spaces but consider "" and ''
          .map(v => stripQuotes(v)) // strip quotes on ends if present
          .map(v => cleanParam(v)) // sanitize to create regexp
          .map(v => new RegExp(v, "i")) // create regexp
          .map(re => values.some(v => re.test(v))) // test regexp against all asset values
          .filter(it => it === false) // don't care about success
          .length;

        if (searchFailures) return false;
      }

      if (this.hideInvalidAssets && asset.statusKey === "missing-information") return false;
      return !(this.hideCompletedAssets && this.completeStatusValues[asset.statusKey]);
    });
    this.displayAssets = this.filterAssets.slice(start, end);
    this.displayAssets = this.parseIndexToShow(this.displayAssets);
    this.recalculateMaxPages();
  }

  parseIndexToShow(assets) {
    return assets.map((asset) => {
      if (typeof asset.statusDetail === "string") return asset;
      const details = [];
      for (const detail of asset.statusDetail) {
        if (detail.message) {
          const assetArray = detail.message.split(":");
          const index = assetArray[0];
          if (index.includes("ProviderContract")) {
            details.push({
              message: `SAP Contract Number: ${assetArray[1]}`,
              status: detail.status,
            });
          }
        }
      }
      if (details.length) asset.statusDetail = details;
      return asset;
    });
  }

  private getAssetDeploymentStatus(): void {
    const assetsMap = {};
    this.assets.forEach((it) => {
      if (this.pendingStatusValues[it.statusKey]) {
        assetsMap[it.id] = it;
      }
      if (it.associatedAccessories && it.associatedAccessories.length) {
        it.associatedAccessories.forEach((it2) => {
          if (this.pendingStatusValues[it2.statusKey]) {
            assetsMap[it2.id] = it2;
          }
        });
      }
      if (it.associatedSoftware && it.associatedSoftware.length) {
        it.associatedSoftware.forEach((it2) => {
          if (this.pendingStatusValues[it2.statusKey]) {
            assetsMap[it2.id] = it2;
          }
        });
      }
    });

    const assetIds = Object.keys(assetsMap);

    if (assetIds.length === 0) {
      this.blocked = false;
      this.disableAll = false;
      return;
    }

    const observable = this.deploymentWorkflowService
      .getAssetsDeploymentStatus(this.workflowTargetInfo.targetId, assetIds);

    let responses = 0;
    const subscription = observable.subscribe((result: any) => {
      if (!result.status) return;

      const target = assetsMap[result.assetId];
      if (!target) {
        console.log(`Results for unknown asset ${result.assetId}`);
        return;
      }

      target.statusKey = result.status;
      if (this.pendingStatusValues[result.status]) {
        target.statusDetail = [];
        return;
      }

      if (result.status === "upload-failed") {
        target.statusDetail = result.messages || "There was a communication error while transmitting to ITSM, please try again later.";
      }

      if (this.completeStatusValues[result.status]) {
        target.disabled = true; // If we succeeded, lock them out from re-sending.
        target.installed = true;
      }

      responses += 1;
      if (responses >= assetIds.length) {
        subscription.unsubscribe();
        this.blocked = false;
        this.disableAll = false;
      }
    });
    this.subscriptions.push(subscription);
  }

  private getDeploymentStatus(): void {
    const observable = this.deploymentWorkflowService
      .getDeploymentStatus(this.workflowTargetInfo.targetId, this.workflowService.workflowConfig.projectId);

    const subscription = observable.subscribe((result: any) => {
      if (!result.status) return;
      if (result.status === "PROCESSING") {
        this.onBoardInProgress = true;
        this.blocked = true;
        return;
      }
      this.onBoardInProgress = false;

      if (result.status === "ERROR") {
        this.errorMessages = result.messages;
        this.blocked = false;
      }
      this.getAssetDeploymentStatus();

      subscription.unsubscribe();
    });
  }

  @handleErrors()
  private async loadData(): Promise<void> {
    if (!this.workflowTargetInfo.targetId) return;
    this.isLegacy = this.workflowService.workflowConfig.targetSystem === TARGET_SYSTEM.LEGACY;

    const [assetList,featurePermissions] = await Promise.all([
      this.deploymentWorkflowService
        .getAssetListFromITSM(this.workflowTargetInfo.targetId)
        .toPromise(),
        this.appSettingsService.getFeaturePermissionsList(["enableMultipleCA", "POR024", "enableApolloProjectQuery", "enableBillFrom"])
    ]);
    const [multipleCA,
      POR024,
      enableApolloProjectQuery,
      enableBillFrom] = [
      featurePermissions["enableMultipleCA"],
      featurePermissions["POR024"],
      featurePermissions["enableApolloProjectQuery"],
      featurePermissions["enableBillFrom"]
    ];
    this.enableMultipleCA = multipleCA && POR024;
    this.enableBillFrom = enableBillFrom;
    if (enableApolloProjectQuery) {
      /*const params: any = `
        id
        purchaseOrderSplit
        defaultContractAccountId
        billToAddress
        payerAddress
        soldToAddress
        hpContractAdminContact
        countryId
        billFromStructure`;
      this.project = await this.projectService.getProjectDetails(this.projectId, params);*/

      const params: any = `
        id
        purchaseOrderSplit: purchase_order_split
        defaultContractAccountId: default_contract_account_id
        billToAddress: address {
          id
          name1
          name2
          line1
          line2
          city
          region
          postalCode: postal_code
          country {
            country_name
            created_at
            geo_region_id
            updated_at
          }
          customShippingLabel1: custom_label_1
          customShippingLabel2: custom_label_2
          deliveryType: delivery_type
          businessPartnerId: business_partner_id
          itsmSiteId: itsm_site_id
          itsmSiteName: itsm_site_name
          itsmBuildingId: itsm_building_id
          itsmBuilding: itsm_building
          buildingTypes: building_types
          country_id
        }
        payerAddress: addressByPayerAddressId {
          id
          name1
          name2
          line1
          line2
          city
          region
          postalCode: postal_code
          country {
            country_name
            created_at
            geo_region_id
            updated_at
          }
          customShippingLabel1: custom_label_1
          customShippingLabel2: custom_label_2
          deliveryType: delivery_type
          businessPartnerId: business_partner_id
          itsmSiteId: itsm_site_id
          itsmSiteName: itsm_site_name
          itsmBuildingId: itsm_building_id
          itsmBuilding: itsm_building
          buildingTypes: building_types
          country_id
        }
        soldToAddress: addressBySoldToAddressId {
          id
          name1
          name2
          line1
          line2
          city
          region
          postalCode: postal_code
          country {
            country_name
            created_at
            geo_region_id
            updated_at
          }
          customShippingLabel1: custom_label_1
          customShippingLabel2: custom_label_2
          deliveryType: delivery_type
          businessPartnerId: business_partner_id
          itsmSiteId: itsm_site_id
          itsmSiteName: itsm_site_name
          itsmBuildingId: itsm_building_id
          itsmBuilding: itsm_building
          buildingTypes: building_types
          country_id
        }
        hpContractAdminContact: contactByHpContractAdminContactId {
          businessPartnerId: business_partner_id
        }
        countryId: country_id
        billFromStructure: bill_from_structure`;
        this.project = await this.hasuraGqlService.getProjectResponseFromHasura(this.workflowTargetInfo.projectId, params);
    } else {
      this.project = await this.projectService.getProjectById(this.projectId).toPromise();
    }

    const {
      defaultContractAccountId,
      billToAddress,
      payerAddress,
      soldToAddress,
      hpContractAdminContact,
    } = this.project;

    if (!defaultContractAccountId && !this.enableMultipleCA) {
      this.warningMessages.push(`Send to ITSM will fail, please create and select a Contract Account.`);
    }
    [billToAddress, payerAddress, soldToAddress, hpContractAdminContact].forEach((it, index) => {
      if (!it.businessPartnerId) {
        this.warningMessages.push(`Send to ITSM will fail. Required Partner
        ${this.partnersValidation[index].humanReadableName} is not set.`);
      }
    });

    const {rows} = assetList;

    this.assetsToUpload = rows
      .filter(it => !it.disabled)
      .reduce((acc, row) => acc.add(row.id, !row.disabled), new KeyByObject())
      .toObject();
    this.associatedAccessoriesToUpload = {};
    this.associatedSoftwareToUpload = {};

    rows.filter(it => this.assetsToUpload[it.id]).forEach((asset) => {
      // Only initially set the associated stuff if the parent is to be up to go as well
      // TODO - this should change once the logic for "Hide Assets / Removals already in ITSM is fixed, but not before
      asset.associatedAccessories.forEach((accessory) => {
        this.associatedAccessoriesToUpload[accessory.id] = !accessory.disabled;
      });
      asset.associatedSoftware.forEach((software) => {
        this.associatedSoftwareToUpload[software.id] = !software.disabled;
      });
    });

    this.assets = [];
    this.assets = selectableAssetModelListFactory(
      rows,
      {
        ...this.assetsToUpload,
        ...this.associatedAccessoriesToUpload,
        ...this.associatedSoftwareToUpload,
      },
    );
    this.recalculateMaxPages();

    const isComplete = this.assets.every((it) => {
      if (!this.completeStatusValues[it.statusKey]) return false;
      if (
        it.associatedAccessories &&
        !it.associatedAccessories.every(it2 => this.completeStatusValues[it2.statusKey])
      ) {
        return false;
      }

      if (
        it.associatedSoftware &&
        !it.associatedSoftware.every(it2 => this.completeStatusValues[it2.statusKey])
      ) {
        return false;
      }

      return true;
    });
    if (isComplete) {
      await this.workflowService.setStepStatus(WorkflowStepStatus.Completed);
    }

    if (rows.some(it => it.collectMethod === "Manual")) { // Explicitly check for manual in case we don't have it set
      await this.deploymentWorkflowService.enableExportPageCounts(this.workflowService.workflowConfig.id).toPromise();
    }

    const inNeedOfMonitoring = this.assets.some((it) => {
      if (this.blockedStatusValues[it.statusKey]) return true;
      if (it.associatedAccessories && it.associatedAccessories.some(it2 => this.blockedStatusValues[it2.statusKey])) {
        return true;
      }

      if (it.associatedSoftware && it.associatedSoftware.some(it2 => this.blockedStatusValues[it2.statusKey])) {
        return true;
      }

      return false;
    });
    if (inNeedOfMonitoring) {
      this.blocked = true;
      this.disableAll = true;
      this.getDeploymentStatus();
    }
    this.setAssetsIdsToUpload();

    this.loadList();
  }

  private recalculateMaxPages() {
    this.maxPages = Math.ceil(this.filterAssets.length / (+this.pageSize));
  }

  onListControlsChange(event) {
    switch (event["key"]) {
      case "page":
        this.currentPage = event["value"];
        break;
      case "search":
        this.currentPage = DEFAULT_PAGE;
        this.searchText = event["value"];
        break;
      case "limit":
        this.currentPage = DEFAULT_PAGE;
        this.pageSize = event["value"];
        break;
      default:
        break;
    }
    this.loadList();
  }

  public defaultContacts = {
    serviceAddressId: null,
    tonerAddressId: null,
  };

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
    public deploymentWorkflowService: DeploymentWorkflowService,
    public dialogService: DialogService,
    public assetService: AssetService,
    public assetRemovalService: AssetRemovalService,
    public accessoryService: AccessoryService,
    public siteService: SiteService,
    public projectService: ProjectService,
    public siteWorkflowService: SiteWorkflowService,
    private confirmDialogService: ConfirmDialogService,
    private costCenterService: CostCenterService,
    private appSettingsService: AppSettingsService,
    private billFromService: BillFromService,
    private hasuraGqlService: HasuraGraphqlService,
  ) {
    super();
  }

  deselectAll(): void {
    this.assetsToUpload = {};
    this.associatedAccessoriesToUpload = {};
    this.associatedSoftwareToUpload = {};
    this.assets.forEach((asset) => {
      asset.selectedNew = false;
      asset.associatedAccessories.forEach((accessory) => {
        accessory.selectedNew = false;
      });
      asset.associatedSoftware.forEach((software) => {
        software.selectedNew = false;
      });
    });
    this.setAssetsIdsToUpload();
  }

  selectAll(): void {
    // Dont let a user select disabled items
    this.assets.forEach((asset) => {
      asset.selectedNew = !asset.disabled;
      if (asset.selectedNew && !this.assetsToUpload[asset.id]) this.assetsToUpload[asset.id] = true;

      asset.associatedAccessories.forEach((accessory) => {
        accessory.selectedNew = !accessory.disabled;
        this.associatedAccessoriesToUpload[accessory.id] = true;
      });
      asset.associatedSoftware.forEach((software) => {
        software.selectedNew = !software.disabled;
        this.associatedSoftwareToUpload[software.id] = true;
      });
    });

    this.setAssetsIdsToUpload();
  }

  @handleErrors()
  async sendToITSM() {
    this.CR978_TMC = await this.appSettingsService.getFeaturePermission(
      "CR978_TMC",
      this.projectId,
    );

    if (this.CR978_TMC) {
      const modalResults = await (PCAcknowledgmentDialogComponent.showDialogModal(
        this.dialogService,
      ).toPromise());

      if (modalResults !== true) return;
    }

    this.assets.forEach((asset) => {
      if (this.assetsToUpload[asset.id]) {
        asset.statusKey = "waiting-for-onboarding";
        asset.statusDetail = [];
      }
      asset.associatedAccessories.forEach((accessory) => {
        if (this.associatedAccessoriesToUpload[accessory.id]) {
          accessory.statusKey = "waiting-for-onboarding";
          accessory.statusDetail = [];
        }
      });
      asset.associatedSoftware.forEach((software) => {
        if (this.associatedSoftwareToUpload[software.id]) {
          software.statusKey = "waiting-for-onboarding";
          software.statusDetail = [];
        }
      });
    });

    this.errorMessages = [];
    this.disableAll = true;
    let serialNumberMappings = [];
    let response;
    try {
      response = await this.deploymentWorkflowService.sendDevicesToITSM(
        this.workflowTargetInfo.targetId,
        this.assetsIdsToUpload,
        this.itsmContractAccount,
      );
      serialNumberMappings = response.serialNumberMappings;
      this.deselectAll();
    } catch (e) {
      this.disableAll = false;
      this.onBoardInProgress = false;
      this.assets.forEach((asset) => {
        if (this.assetsToUpload[asset.id]) {
          asset.statusKey = "error";
          asset.statusDetail = [];
        }
        asset.associatedAccessories.forEach((accessory) => {
          if (this.associatedAccessoriesToUpload[accessory.id]) {
            accessory.statusKey = "error";
            accessory.statusDetail = [];
          }
        });
        asset.associatedSoftware.forEach((software) => {
          if (this.associatedSoftwareToUpload[software.id]) {
            software.statusKey = "error";
            software.statusDetail = [];
          }
        });
      });
      throw new Error(e.message);
    }

    const serialNumberMap = serialNumberMappings.reduce((acc, it) => { acc[it.id] = it; return acc; }, {});
    this.assets.forEach((asset) => {
      if (serialNumberMap[asset.id]) asset.serialNumber = serialNumberMap[asset.id].serialNumber;
      if (asset.associatedSoftware) {
        asset.associatedSoftware.forEach((it) => {
          if (serialNumberMap[it.id]) it.serialNumber = serialNumberMap[it.id].serialNumber;
        });
      }
      if (asset.associatedAccessories) {
        asset.associatedAccessories.forEach((it) => {
          if (serialNumberMap[it.id]) it.serialNumber = serialNumberMap[it.id].serialNumber;
        });
      }
    });
    if (response.didOnboardCustomer) await this.getDeploymentStatus();
    else await this.getAssetDeploymentStatus();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.subscriptions.forEach((subscription) => {
      if (!subscription.closed) subscription.unsubscribe();
    });
  }

  @handleErrors()
  async loadDeviceDropdownsData(siteId: string) {
    const {
      dropdownGroupsList,
      dropdowns,
      dropdownSiteContacts,
      dropdownPurchaseOrders,
      dropdownContractList,
    } = await this.siteWorkflowService.getAssetsDropdownData(siteId, this.projectId);
    this.purchasOrdersList = dropdownPurchaseOrders;
    this.groupList = dropdownGroupsList;
    this.siteContactsList = dropdownSiteContacts;
    this.dropdowns = dropdowns;
    this.siteContract = dropdownContractList;
  }

  @handleErrors()
  async showContent(index: number, asset: SelectableAsset) {
    if (this.selectedIndex === index) return;

    if (this.assetChanged) {
      const result = await this.workflowService.showUnsavedChangesWarning();

      switch (result) {
        case "save":
          await this.save({asset: this.currentAssetChanged, changes: this.assetChanged});
          if (!this.successfulSave) return;
          break;
        case "continue":
          this.clearAndCloseCurrentAsset();
          break;
        case "cancel":
          return;
        default:
          break;
      }
    }
    this.assetOpened = true;
    await this.setSolutionData(asset);
    if (this.currentDeviceType === "asset") {
      await this.loadDeviceDropdownsData(this.currentAsset.siteId);
    }
    this.selectedIndex = index;
  }

  @handleErrors()
  async setSolutionData(asset: SelectableAsset) {
    if (asset.type === "asset") {
      this.currentAsset = await this.assetService.getAsset(asset.id);

      const params: any = `
        countryId
        billFromStructure
        `;
      const projectInfo = await this.projectService.getProjectDetails(this.projectId, params);
      if(!this.enableBillFrom || projectInfo.countryId != 'IN'){
        if(this.currentAsset.software){
          for(let software of this.currentAsset.software){
            delete software['billFromBPIDId'];
          }
        }
      }

      // Filter and fill Contacts for Selected Device Array
      this.itsmSiteContactsForSelectedDevice = this.itsmSiteContactsWithItsmId.filter(contact => (
        !contact.siteId ||
        (this.currentAsset.siteId && contact.siteId === this.currentAsset.siteId)
      ));
      this.currentDevice = await this.currentAsset.availableDevices.find(d => d.id === this.currentAsset.deviceId);
    } else if (asset.type === "accessory") {
      this.currentAccessory = await this.accessoryService.getAccessory(asset.id);
    } else {
      this.currentSoftware = await this.assetService.getSoftware(asset.id);
    }
    this.currentDeviceType = asset.type;
  }

  @handleErrors()
  async individualAccessoryChange(data: DataFromEditAccessoryModel) {
    if (data.errors) throw new Error(data.errors);
    else if (data.accessoriesSaved) {
      try {
        this.loading = true;
        await this.loadData();
        this.clearAndCloseCurrentAsset();
        this.loading = false;
      } catch (e) {
        this.loading = false;
        throw e;
      }
    }
    this.assetChanged = data.changes;
    if (!data.accessories[0].keep) await this.remove(this.assets[this.selectedIndex]);
  }

  individualSoftwareChange(data) {
    this.assetChanged = data.changes;
    if (data.changes) this.softwareSaved = false;
  }

  @handleErrors()
  async saveSoftware() {
    if (!this.currentSoftware.change) return false;
    const {updated} = await this.assetService.saveSoftware([
      new SoftwareInputDataGqlModel(this.currentSoftware),
    ]);
    this.currentSoftware.change = false;
    this.assetChanged = false;
    this.softwareSaved = true;

    try {
      this.loading = true;
      await this.loadData();
      this.clearAndCloseCurrentAsset();
      this.loading = false;
    } catch (e) {
      this.loading = false;
      throw e;
    }

    return updated;
  }

  @handleErrors()
  async save(data: DataFromEditAssetModel) {
    this.successfulSave = false;
    let success;
    try {
      if (data.changes) {
        this.internalLoading = true;
        if (this.currentDeviceType === "asset") {
          const errors = await this.assetValidations(data.asset,this.enableAssetColorsFlag);
          if (errors.length) {
            const multiError = new MultiError("");
            multiError.errors = errors;
            this.error = multiError;
            this.internalLoading = false;
            return;
          }

          const {updated} = await this.assetService.saveAsset(data.asset);
          success = updated;
        } else if (this.currentDeviceType === "accessory") {
          const {updated} = await this.accessoryService.saveAccessory(this.currentAccessory);
          success = updated;
        } else success = await this.saveSoftware();

        if (success) {
          await this.loadData();
          this.successfulSave = true;
        }
        this.internalLoading = false;
      }
    } catch (e) {
      this.internalLoading = false;
      throw e;
    }

    this.clearAndCloseCurrentAsset();
  }

  @handleErrors()
  async remove(asset: SelectableAsset) {
    const doRemove = await this.confirmDialogService.confirm(
      "Confirm Removal",
      "Are you sure you want to remove this item?",
    );
    if (!doRemove) return;

    try {
      this.internalLoading = true;
      if (this.currentDeviceType === "asset") {
        this.checkDeviceIsAssociated(asset);
        await this.assetService.deleteById(asset.id);
      } else if (this.currentDeviceType === "accessory") {
        await this.accessoryService.deleteAccessory(asset.id);
        if (asset.assetId) this.devicesAssoc[asset.assetId][asset.type] -= 1;
      } else {
        await this.assetService.deleteSoftware(asset.id);
        if (asset.assetId) this.devicesAssoc[asset.assetId][asset.type] -= 1;
      }
      await this.loadData();
      this.selectedIndex = -1;
      this.internalLoading = false;
    } catch (e) {
      this.internalLoading = false;
      throw e;
    }
  }

  checkDeviceIsAssociated(asset: SelectableAsset) {
    const association = this.assets.find(a => a.type !== "asset" && a.assetId === asset.id);
    if (association) throw Error("This device is associated with another solution and it can't be deleted.");
  }

  async closeDetails(data: DataFromEditAssetModel) {
    if (data.changes) {
      const result = await this.workflowService.showUnsavedChangesWarning();

      switch (result) {
        case "save":
          await this.save(data);
          break;
        case "continue":
          this.clearAndCloseCurrentAsset();
          break;
        case "cancel":
        default:
          break;
      }
    } else {
      this.clearAndCloseCurrentAsset();
    }
  }

  async currentAssetChangeDetected(data: DataFromEditAssetModel) {
    const accessoriesAssociationChange = this.assetAssociations.accessories !== data.asset.standaloneAccessories.length;
    const softwareAssociationChange = this.assetAssociations.software !== data.asset.software.length;

    if (accessoriesAssociationChange || softwareAssociationChange) {
      this.checkSolutionsAssociationChanges(data.asset, accessoriesAssociationChange);
    }

    this.currentAssetChanged = data.asset;
    this.assetChanged = data.changes;
  }

  checkSolutionsAssociationChanges(asset: AssetGqlModel, accessories: boolean) {
    this.assetAssociations.accessories = asset.standaloneAccessories.length;
    this.assetAssociations.software = asset.software.length;

    const solution = accessories ? "accessory" : "software";
    const solutionsIds = accessories ?
      asset.standaloneAccessories.reduce((acc, it) => {
        acc[it.id] = "0";
        return acc;
      }, {}) :
      asset.software.reduce((so, it) => {
        so[it.id] = "0";
        return so;
      }, {});

    this.assets.forEach((a) => {
      if (a.type === solution) {
        if (!a.assetId && solutionsIds[a.id]) {
          a.assetAssociatedName = this.assets[this.selectedIndex].description;
          a.assetId = asset.id;
          this.setDeviceAssociation(a);
        } else if (a.assetId === asset.id && !solutionsIds[a.id]) {
          if (this.devicesAssoc[a.assetId][a.type] > 0) this.devicesAssoc[a.assetId][a.type] -= 1;
          a.assetAssociatedName = null;
          a.assetId = null;
        }
      }
    });
  }

  setDeviceAssociation(solution: SelectableAsset) {
    if (!this.devicesAssoc[solution.assetId]) {
      this.devicesAssoc[solution.assetId] = {[solution.type]: 1};
    } else if (!this.devicesAssoc[solution.assetId][solution.type]) {
      this.devicesAssoc[solution.assetId][solution.type] = 1;
    } else this.devicesAssoc[solution.assetId][solution.type] += 1;
  }

  async assetValidations(asset: AssetGqlModel, enablePOR089_2 = false) {
    const assetForValidation: AssetDataValidationModel = {
      installDate: asset.installDate,
      orderDate: asset.orderDate,
      initialPageCountColor: asset.initialPageCountColor,
      initialPageCountColorProfessional: asset.initialPageCountColorProfessional,
      initialPageCount: asset.initialPageCount,
      initialPageCountColorGeneralOffice: asset.initialPageCountColorGeneralOffice,
      initialPageCountColorAccent: asset.initialPageCountColorAccent,
      initialPageCountOther: asset.initialPageCountOther,
      printCapability: asset.printCapability,
    };

    return this.assetService.assetDataValidations(assetForValidation, false,enablePOR089_2);
  }

  clearAndCloseCurrentAsset() {
    this.assetOpened = false;
    this.assetChanged = false;
    this.selectedIndex = -1;
    this.currentAsset = new AssetGqlModel({});
    this.currentDevice = new AssetAvailableDeviceModel({});
  }

  checkDirty(): boolean {
    return this.assetChanged;
  }

  private async loadBillFromBuildings() {
    this.billFromAccounts = await this.billFromService.getBillFromBuildings(
      this.projectId,
      this.project.country.countryId,
    );
  }

  async loadFinancialContact() {
    this.POR954_TMC = await this.appSettingsService.getFeaturePermission("POR954_TMC", this.projectId);
    if(this.POR954_TMC) {
      await this.projectService.getItsmContacts(this.projectId, false, true);

    }
    const params: any = {
      projectId: this.projectId,
      uiAction: "PROJECT-CONTACT",
      queryType: "Contact",
    };
 
    if (this.targetSystem === "pmpsp" || this.targetSystem === "mimp" ||
    this.targetSystem === "mpflexr" || this.targetSystem === TARGET_SYSTEM.PMPS_SELL_THROUGH ||
    this.targetSystem === TARGET_SYSTEM.PMPS_BILL_THROUGH) {
      params.query = this.POR954_TMC ? Query.PARTNER_CONTACTS_WITH_ACTIVE_FILTER : Query.PARTNER_CONTACTS;
    } else {
      params.query = this.POR954_TMC ? Query.CUSTOMER_CONTACTS_WITH_ACTIVE_FILTER : Query.CUSTOMER_CONTACTS;
    }
    const contactResponse = await this.hasuraGqlService.getResponseFromHasura(params);
 
    const contacts = contactResponse && contactResponse.body && contactResponse.body.data &&
      contactResponse.body.data.contacts && contactResponse.body.data.contacts.length > 0 ?
      contactResponse.body.data.contacts : [];
    if (this.targetSystem === TARGET_SYSTEM.PMPS_BILL_THROUGH) await this.getHpInvoiceContact(contacts);
   this.setItsmContacts(contacts);
    return this.itsmContacts;
  }
  setItsmContacts(contacts) {
    if (contacts.length) {
      contacts.forEach(contact => contact.name = `${contact.firstName} ${contact.lastName}`);
      this.itsmContacts = contacts;
      this.itsmContactsWithItsmIds = this.itsmContacts.filter(it => it.itsmContactId);
      this.itsmContactsWithBpId = contacts.filter(it => it.businessPartnerId);
      this.nonHpItsmContactsWithBpId = this.itsmContactsWithBpId.filter(it => !it.isHpContact);
      this.itsmContactsWithBpIdMap =
        this.itsmContactsWithBpId.reduce((acc, it) => { acc[it.id] = it; return acc; }, {});
      this.buildContactTypes();
    }
  }

  buildContactTypes() {
    for (const contact of this.itsmContactsWithBpId) {
      if (!contact.isHpContact) {
        this.ContractualContactTypes.billTo.push(contact);
        this.ContractualContactTypes.invoice.push(contact);
      } else if (contact.contactTypes) {
        Object.keys(contact.contactTypes).forEach((type) => {
          if (type !== "billTo" && type !== "invoice" && this.ContractualContactTypes[type]) {
            this.ContractualContactTypes[type].push(contact);
          }
        });
      }
    }
 
    const contactTypesArray = Object.keys(this.ContractualContactTypes);
    for (const type of contactTypesArray) {
      if (!this.ContractualContactTypes[type].length && (type === "billTo" || type === "invoice")) {
        this.ContractualContactTypes[type] = this.nonHpItsmContactsWithBpId;
      } else if (!this.POR954_TMC && !this.ContractualContactTypes[type].length) this.ContractualContactTypes[type] = this.itsmContactsWithBpId;
    }
  }
  async getHpInvoiceContact(contacts) {
    const params: any = {
      projectId: this.projectId,
      uiAction: "PROJECT-CONTACT",
      queryType: "Contact",
      query: Query.CUSTOMER_CONTACTS,
    };
    const contactResponse = await this.hasuraGqlService.getResponseFromHasura(params);
    contacts.forEach((itm) => {
      if (itm.contactTypes && itm.contactTypes["hpInvoice"] === true) {
        itm.contactTypes["hpInvoice"] = false;
      }
    });
    const customerContacts = contactResponse && contactResponse.body && contactResponse.body.data &&
      contactResponse.body.data.contacts && contactResponse.body.data.contacts.length > 0 ?
      contactResponse.body.data.contacts : [];
    customerContacts.forEach((contact) => {
      if (contact.contactTypes && contact.contactTypes["hpInvoice"] === true) contacts.push(contact);
    });
  }
}
